import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { AdaContextProvider } from "@/context/AdaContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import DataRoom from "@/pages/DataRoom";
import DocumentViewer from "@/pages/DocumentViewer";
import Settings from "@/pages/Settings";
import UsersPage from "@/pages/Users";
import ActivityPage from "@/pages/Activity";
import OwnerAccessRequests from "@/pages/OwnerAccessRequests";
import RequestAccess from "@/pages/RequestAccess";
import AcceptInvite from "@/pages/AcceptInvite";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import TasksPage from "@/pages/Tasks";
import AdaFeedback from "@/pages/AdaFeedback";
import { Toaster } from "@/components/Toaster";
import ErrorBoundary from "@/components/ErrorBoundary";
import { FileProgressProvider } from "@/context/FileProgressContext";
import FileProgressBar from "@/components/FileProgressBar";

function App() {
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <AuthProvider>
            <FileProgressProvider>
            <AdaContextProvider>
            <Toaster />
            <FileProgressBar />
            <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="rooms" replace />} />
              <Route path="rooms" element={<Dashboard />} />
              <Route path="rooms/:id" element={<DataRoom />} />
              <Route path="rooms/:roomId/view/:docId" element={<DocumentViewer />} />
              <Route path="users" element={<ProtectedRoute adminOnly><UsersPage /></ProtectedRoute>} />
              <Route path="activity" element={<ProtectedRoute adminOnly><ActivityPage /></ProtectedRoute>} />
              <Route path="owner/access-requests" element={<ProtectedRoute ownerOnly><OwnerAccessRequests /></ProtectedRoute>} />
              <Route path="access-requests" element={<RequestAccess />} />
              <Route path="tasks" element={<TasksPage />} />
              <Route path="ada-feedback" element={<ProtectedRoute adminOnly><AdaFeedback /></ProtectedRoute>} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </AdaContextProvider>
            </FileProgressProvider>
          </AuthProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
